// extracted by mini-css-extract-plugin
export var actionButton = "_xg-2";
export var card = "_xg-0";
export var errorCard = "_xg-3";
export var row = "_xg-1";